import formatMoney from "./formatMoney";
export default {
  install(Vue, options) {
    //货币格式化  1000->1,000
    Vue.filter("formatMoney", formatMoney)
  },
};



// WEBPACK FOOTER //
// ./src/filters/index.js